// extracted by mini-css-extract-plugin
export var attachButton = "_cc-8";
export var sendButton = "_cc-2";
export var sendDisabled = "_cc-4";
export var sendEnabled = "_cc-3";
export var sendIcon = "_cc-6";
export var sendIconDisabled = "_cc-7";
export var sendStreaming = "_cc-5";
export var textarea = "_cc-1";
export var wrapper = "_cc-0";